import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed top-0 right-0 h-full w-80 bg-background border-l shadow-xl z-[110] flex flex-col"
}
const _hoisted_2 = { class: "h-14 border-b flex items-center justify-between px-4 shrink-0" }
const _hoisted_3 = { class: "p-4 space-y-6" }
const _hoisted_4 = { class: "flex items-center gap-2 mb-3" }
const _hoisted_5 = { class: "h-8 w-8 rounded-lg bg-primary/10 flex items-center justify-center" }
const _hoisted_6 = { class: "font-semibold text-sm" }
const _hoisted_7 = { class: "space-y-1 ml-2" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "flex-1 text-sm" }
const _hoisted_10 = { class: "p-4 border-t" }
const _hoisted_11 = { class: "text-xs text-muted-foreground text-center" }

import { computed } from 'vue'
import { useHelpCenter } from '@/composables/useHelpCenter'
import { Button } from '@/components/ui/button'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Badge } from '@/components/ui/badge'
import {
  X,
  Rocket,
  LayoutDashboard,
  Building2,
  FolderKanban,
  ListTodo,
  ClipboardList,
  Layers,
  MessageSquarePlus,
  Ticket,
  PackageCheck,
  Users,
  Calendar,
  Video,
  FileText,
  Receipt,
  ShoppingCart,
  UserCog,
  Settings,
  Bot,
  Shield,
  Briefcase,
  Handshake,
  UsersRound,
  Wrench,
  ChevronRight,
} from 'lucide-vue-next'

import type { HelpModule, ModuleGroupConfig } from '@/types/help'


export default /*@__PURE__*/_defineComponent({
  __name: 'HelpModulesDrawer',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close", "selectModule"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { availableModules, navigateToModule } = useHelpCenter()

// Configuración de grupos de módulos
const moduleGroups: ModuleGroupConfig[] = [
  {
    id: 'inicio',
    title: 'Inicio',
    icon: 'Rocket',
    modules: ['getting-started', 'dashboard'],
  },
  {
    id: 'proyectos',
    title: 'Gestión de Proyectos',
    icon: 'FolderKanban',
    modules: ['projects', 'backlog', 'requirements', 'epics', 'releases'],
  },
  {
    id: 'crm',
    title: 'CRM y Ventas',
    icon: 'Handshake',
    modules: ['crm', 'organizations', 'quotations', 'sales-orders'],
  },
  {
    id: 'colaboracion',
    title: 'Colaboración',
    icon: 'UsersRound',
    modules: ['calendar', 'meetings', 'documents'],
  },
  {
    id: 'soporte',
    title: 'Soporte al Cliente',
    icon: 'Ticket',
    modules: ['tickets', 'petitions'],
  },
  {
    id: 'configuracion',
    title: 'Configuración',
    icon: 'Wrench',
    modules: ['profile', 'admin', 'copilot', 'super-admin'],
  },
]

// Mapa de iconos
const iconMap: Record<string, unknown> = {
  Rocket,
  LayoutDashboard,
  Building2,
  FolderKanban,
  ListTodo,
  ClipboardList,
  Layers,
  MessageSquarePlus,
  Ticket,
  PackageCheck,
  Users,
  Calendar,
  Video,
  FileText,
  Receipt,
  ShoppingCart,
  UserCog,
  Settings,
  Bot,
  Shield,
  Briefcase,
  Handshake,
  UsersRound,
  Wrench,
}

const getIcon = (iconName: string) => {
  return iconMap[iconName] || FolderKanban
}

// Filtrar grupos que tienen módulos disponibles para el usuario
const filteredGroups = computed(() => {
  const availableIds = new Set(availableModules.value.map((m) => m.id))

  return moduleGroups
    .map((group) => ({
      ...group,
      availableModules: group.modules
        .filter((modId) => availableIds.has(modId))
        .map((modId) => availableModules.value.find((m) => m.id === modId)!)
        .filter(Boolean),
    }))
    .filter((group) => group.availableModules.length > 0)
})

const handleSelectModule = (moduleId: HelpModule) => {
  navigateToModule(moduleId)
  emit('selectModule', moduleId)
  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      "enter-active-class": "transition-all duration-300 ease-out",
      "leave-active-class": "transition-all duration-200 ease-in",
      "enter-from-class": "translate-x-full opacity-0",
      "enter-to-class": "translate-x-0 opacity-100",
      "leave-from-class": "translate-x-0 opacity-100",
      "leave-to-class": "translate-x-full opacity-0"
    }, {
      default: _withCtx(() => [
        (__props.isOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("header", _hoisted_2, [
                _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "font-semibold" }, "Explorar Guías", -1)),
                _createVNode(_unref(Button), {
                  variant: "ghost",
                  size: "icon",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(X), { class: "h-4 w-4" })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_unref(ScrollArea), { class: "flex-1" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGroups.value, (group) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: group.id
                      }, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(getIcon(group.icon)), { class: "h-4 w-4 text-primary" }))
                          ]),
                          _createElementVNode("h3", _hoisted_6, _toDisplayString(group.title), 1),
                          _createVNode(_unref(Badge), {
                            variant: "secondary",
                            class: "ml-auto text-xs"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(group.availableModules.length), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.availableModules, (mod) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: mod.id,
                              class: "w-full flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-muted text-left transition-colors group",
                              onClick: ($event: any) => (handleSelectModule(mod.id))
                            }, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(getIcon(mod.icon)), { class: "h-4 w-4 text-muted-foreground group-hover:text-primary transition-colors" })),
                              _createElementVNode("span", _hoisted_9, _toDisplayString(mod.title), 1),
                              _createVNode(_unref(ChevronRight), { class: "h-4 w-4 text-muted-foreground/50 group-hover:text-primary transition-colors" })
                            ], 8, _hoisted_8))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(availableModules).length) + " módulos disponibles ", 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition-opacity duration-300",
      "leave-active-class": "transition-opacity duration-200",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (__props.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 bg-black/20 z-[105]",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})